<div *ngIf="this.isLoading" class="se-loader">
</div>
<div class=" p-2">
  <div class="top-div">
    <div class="filter-sec pt-2">
      <input type="text" title={{labels.oemSearchText|translate}} aria-label="search" class="input-globalsearch" size="50" placeholder={{labels.search|translate}} (input)="dt.filterGlobal($event.target.value, 'contains')">
      <a class="SearchLink" >
        <em class="fa fa-search SearchIcon" ></em>
      </a>
      <button class="se-button cursorPointerHand" (click)="AddOem()" >
        {{labels.btnAddOem | translate}}
      </button>
      <button class="se-button cursorPointerHand" (click)="ExportOem()" >
        {{labels.btnExport | translate}}
      </button>
    </div>
  </div>
  <div class="gridtbl-div mb-3">
    <div>
      <div class="rectangle-grid">
        <p-table #dt [columns]="cols" [value]="oemDetails" [paginator]="isPagination" [rows]="10" [globalFilterFields]="['oid','oemName','oemDesc']">
          <ng-template pTemplate="header" let-columns>
            <tr>
              <th scope="col" *ngFor="let col of columns" [pSortableColumn]="col.field" [ngStyle]="{'width': col.width}">
                {{col.header | translate}}
                <p-sortIcon [field]="col.field" ariaLabel="Activate to sort" ariaLabelDesc="Activate to sort in descending order" ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-rowData let-columns="columns" let-i="rowIndex">
            <tr class="rowHeight">
              <td class="rule-desc" *ngFor="let col of columns">
                <span title="{{rowData[col.field]}}">
                  {{rowData[col.field]}}
                </span>
              </td>

            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage" let-columns>
            <tr *ngIf="noData">
              <td [attr.colspan]="columns.length">
                {{labels.noRecords | translate}}
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>
</div>

<div class="se-dialog" *ngIf="showmodal">
  <p-toast class="mt10" position="top-center" key="error"></p-toast>
  <div class="se-dialog-holder">
    <div class="se-complex-header">
      <h3 class="se-dialiog-title">{{contentHeader | translate}}</h3>
    </div>
    <div class="se-dialog-body">
      <div *ngIf="this.isLoading" class="se-loader"></div>
      <div class="se-inline-form">

        <div class="form-ele col-md-12">
          <label for="Oid" class="se-label col-md-3">{{labels.oid | translate}}<span>*</span></label>
          <input id="Oid" placeholder="{{labels.oid | translate}}" type="text" autocomplete="off" class="se-form-control col-md-6" #TxtOid="ngModel" [(ngModel)]="oId" #txtOid appRequiredElementValidator (keyup)="validate()"
                 [minLength]="1" [maxLength]="10">
          <div class="d-block brand-error se-fs-12" *ngIf="!TxtOid.errors?.requiredElementValidator && (TxtOid.dirty || TxtOid.touched)">
            {{oemIdRequired}}
          </div>
        </div>

        <div class="form-ele col-md-12">
          <label for="TxtOemName" class="se-label col-md-3">{{labels.oemName | translate}}<span>*</span></label>
          <input id="OemName" aria-label="txtOemName" placeholder="{{labels.oemName | translate}}" type="text" autocomplete="off" (keyup)="validate()"
                 class="se-form-control col-md-6" #TxtOemName="ngModel" [(ngModel)]="oemName" appRequiredElementValidator [minLength]="1" [maxLength]="50">
          <div class="d-block brand-error se-fs-12" *ngIf="!TxtOemName.errors?.requiredElementValidator && (TxtOemName.dirty || TxtOemName.touched)">
            {{oemNameRequired}}
          </div>
        </div>
        <div class="form-ele col-md-12">
          <label for="txtOemDesc" class="se-label col-md-3">{{labels.oemDesc | translate}}</label>
          <input id="txtOemDesc" placeholder="{{labels.oemDesc | translate}}" type="text" autocomplete="off"
                 class="se-form-control col-md-6" [(ngModel)]="oemDesc" [minLength]="1" [maxLength]="250">
        </div>
      </div>
    </div>
    <div class="se-dialog-footer">
      <button class="se-button" (click)="closeModal()">{{labels.cancel | translate}}</button>
      <button class="se-button button-primary" (click)="SaveOem(txtOid,txtOemName)" [disabled]="formInvalid"
              [ngClass]="{ 'disabled-cls': formInvalid }">
        {{labels.save | translate}}
      </button>
    </div>
  </div>
</div>



<template ngbModalContainer>
</template>
<p-toast class="mt10" position="top-center" key="success"></p-toast>
<p-toast class="mt10" position="top-center" key="error"></p-toast>

